import { compose, withHandlers } from 'recompose';

import withToggle from '../../../../../common/hoc/withToggle';
import withNotifications from '../../../../../common/withNotifications';
import { updateSubscriptionStatus } from '../../../../../memberships/subscriptions/actions';
import { t } from '../../../../../../modules/infra/i18n';

const CustomerMembershipInfoContainer = compose(
  withNotifications,
  withToggle('busy', false),
  withHandlers({
    performAction: props => async (action) => {
      props.busyOn();

      try {
        await updateSubscriptionStatus(props.activeType, props.activeId, props.subscription.id, action);
        await props.fetchSubscription();
      } finally {
        props.busyOff();
      }

      props.addNotification({
        title: t('customers:form.membership.success_title'),
        level: 'success',
        message: t('customers:form.membership.subscription_updated_message'),
      });
    },
  }),
);

export default CustomerMembershipInfoContainer;
